import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NormaService {
  private data = null;
	private url = environment.serviceApi;
   constructor(public http: Http) { }
   
  getNormas(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/norma' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getNorma(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/norma/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaNorma(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/norma', {
				norma_nome: data.norma_nome,
				norma_descricao: data.norma_descricao,
				norma_data: data.norma_data,
				norma_arquivo: data.norma_arquivo,
				norma_arquivo_nome: data.norma_arquivo_nome,
				norma_status: data.norma_status
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaNorma(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/norma/' + data.norma_id, {
				norma_nome: data.norma_nome,
				norma_descricao: data.norma_descricao,
				norma_data: data.norma_data,
				norma_arquivo: data.norma_arquivo,
				norma_arquivo_nome: data.norma_arquivo_nome,
				norma_status: data.norma_status
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaNorma(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/norma/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
